//Basic math:

require("./operator_add.js");
require("./operator_subtract.js");
require("./operator_multiply.js");
require("./operator_divide.js");
require("./operator_scratch_mod.js");
require("./operator_js_mod.js");
require("./operator_sign.js");
require("./operator_fixed.js");
require("./operator_mathop.js");

//Randomizing:

require("./operator_random.js");

//Conditional:

require("./operator_equals.js");
require("./operator_gt.js");
require("./operator_lt.js");
require("./operator_and.js");
require("./operator_or.js");
require("./operator_not.js");
require("./operator_outputif.js");

//Constants:

require("./operator_true.js");
require("./operator_false.js");
require("./operator_nan.js");
require("./operator_null.js");
require("./operator_infinity.js");
require("./operator_empty_string.js");
require("./operator_newline.js");

//Rounding:

require("./operator_round.js");

//Converters/Casting:

require("./operator_tostring.js");
require("./operator_tonumber.js");
require("./operator_toboolean.js");
require("./operator_joinstring.js");
require("./operator_stringlength.js");
require("./operator_stringtrim.js");
require("./operator_stringlowercase.js");
require("./operator_stringuppercase.js");
